const config = {
  // publicKey: 'TEST-a417e3a6-e16b-4d4d-85ec-572a8cc1cb63',
  publicKey: 'APP_USR-5c00cd57-68fd-45ae-bdd1-00893c5e8678',
  endpointBaseUrl: 'https://us-central1-marcelinopasseri.cloudfunctions.net',
};

export default config;
